const initialState = {
    allBillingChannels: [],
}

const billingChannelReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'GET_BILLING_CHANNELS':
            return {
                ...state,
                allBillingChannels: action?.payload
            };
        default:
            return {
                ...state
            }
    }
}

export default billingChannelReducer;